// Utility to convert "background-color: red; width: 50%;" 
// into { backgroundColor: "red", width: "50%" }
function parseInlineStyles(styleString = "") {
  const styleObject = {};
  // Split on ; to get each rule, ignoring empty entries
  styleString.split(";").forEach((rule) => {
    const [prop, value] = rule.split(":").map((str) => str.trim());
    if (!prop || !value) return;
    // Convert CSS property to camelCase: background-color => backgroundColor
    const camelProp = prop.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
    styleObject[camelProp] = value;
  });
  return styleObject;
}
export default parseInlineStyles;
